import multiLocation from './multiLocation';

export default multiLocation;
